<template>
    <Row type="none"></Row>
</template>

<script>
import Row from "../../components/html/Row";

export default {
    name: "ExcelError",
    components: {Row},
    created() {
        this.$router.back()
    }
}
</script>

<style scoped>

</style>